import "react-quill-new/dist/quill.snow.css";
import "./App.css";
import { Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ConfigProvider, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
// import "remixicon/fonts/remixicon.css";
import "antd/dist/reset.css";
import withUserContext, { UserContext } from "./contexts/user";
import routes from "./constants/routes";
import withHelmet from "./utilities/withHelmet";
import withSidebar from "./utilities/withSidebar";
import themeConfig from "./config/theme.json";
import '@ant-design/v5-patch-for-react-19';

function App() {
  Spin.setDefaultIndicator(<LoadingOutlined style={{ fontSize: 24 }} spin />);
  return (
    <ConfigProvider theme={themeConfig}>
      <Suspense fallback={<div className="suspenece-spin"><Spin /></div>}>
        <UserContext.Consumer>
          {(user) => {
            if (user.status === "unknown" || user.status === "loading") {
              return (
                <div
                  style={{
                    width: "100vw",
                    height: "100vh",
                    background: "#fff",
                  }}
                ></div>
              );
            }
            return (
              <BrowserRouter>
                <Routes>
                  {Object.values(routes).map((route, index) => {
                    if (user.status === "loggedin") {
                      if (route.allowAccessWhenLoggedIn === false) {
                        return (
                          <Route
                            path={route.path}
                            element={<Navigate to='/' replace={true} />}
                            key={index}
                          />
                        );
                      } else {
                        return (
                          <Route
                            path={route.path}
                            Component={withHelmet(
                              route.pageTitle,
                              route.withSidebar
                                ? withSidebar(route.component)
                                : route.component
                            )}
                            key={index}
                          />
                        );
                      }
                    } else if (route.requireLogin === false) {
                      return (
                        <Route
                          path={route.path}
                          Component={withHelmet(
                            route.pageTitle,
                            route.withSidebar
                              ? withSidebar(route.component)
                              : route.component
                          )}
                          key={index}
                        />
                      );
                    } else {
                      return (
                        <Route
                          path={route.path}
                          element={<Navigate to='/login' replace={true} />}
                          key={index}
                        />
                      );
                    }
                  })}
                </Routes>
              </BrowserRouter>
            );
          }}
        </UserContext.Consumer>
      </Suspense>
    </ConfigProvider>
  );
}

export default withUserContext(App);
